import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { PrinterSetting as SharedPrinterSetting } from "@components/Common/PrinterSetting";

import { setIsConfigurationPrinterClicked, store as kdsStore } from "../store";
import { buildKdsPrinterSettingConfig } from "./printerSettingConfig";

type PrinterRowData = Record<string, unknown> & { shopId?: string };

type PrinterSettingSharedProps = {
    rowData: PrinterRowData;
    oneShop: boolean;
    setDataIsUpdated: (value: boolean | number) => void;
    isDataUpdated?: number | boolean;
};

export default function PrinterSettingShared({
    rowData,
    oneShop,
    setDataIsUpdated,
}: PrinterSettingSharedProps) {
    const { t } = useTranslation();
    const { isConfigurationPrinterClicked } = useSnapshot(kdsStore);

    const config = React.useMemo(() => buildKdsPrinterSettingConfig(t), [t]);

    return (
        <SharedPrinterSetting
            isOpen={isConfigurationPrinterClicked}
            onClose={() => setIsConfigurationPrinterClicked(false)}
            rowData={rowData}
            oneShop={oneShop}
            config={config}
            onSaved={() => setDataIsUpdated(true)}
        />
    );
}
